import Factory from '@/modules/Factory'

/**
 * @class 
 * @extends Factory
 * @description Factory authentication module 
*/
export default class AuthenticationFactory extends Factory{

    /**
     * @static
     * @override 
     * @method create Instance a concrete object based on cloud provider selected
     * @param {String} provider Backend provider 
     * @param {Object} settings Module settings custom for backend provider selected
     */
    static create(provider,context,settings){
        let Provider = null
        let moduleInstance = null
        switch(provider){
            case "aws":
                Provider = require("./implementations/AWSOauth2").default
                moduleInstance = new Provider(context,settings)
                break
            default: 
                throw "No provider '"+provider+"' available" 
        }
        return moduleInstance
    }
}